import { useState } from 'react';
import { useHistory } from 'react-router';

import { useActiveSessionStore } from '@/hooks/useActiveSessionStore';
import { useExitSession } from '@/hooks/useExitSession';

import styles from './SessionHeader.module.css';

import { BackModal } from '../BackModal/BackModal';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { IconRotate } from '../Icon/types';
import { Indicator } from '../Indicator/Indicator';
import { PageHeader } from '../PageHeader/PageHeader';
import { SensorHubIndicator } from '../SensorHubIndicator/SensorHubIndicator';

interface ISessionHeaderProps {
  title: string;
  startDate?: string;
  isHubFlow: boolean;
  clientId: string;
}

export const SessionHeader = ({ title, startDate, isHubFlow, clientId }: ISessionHeaderProps) => {
  const history = useHistory();
  const { exit } = useExitSession(isHubFlow);
  const [isBackModalOpen, setIsBackModalOpen] = useState(false);
  const { closeActiveSession } = useActiveSessionStore();

  const date = startDate ? new Date(startDate) : new Date();
  const currentDate = date.toLocaleDateString(undefined, {
    month: 'short',
    year: 'numeric',
    day: 'numeric',
  });
  const currentTime = new Date().toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

  const onBack = () => {
    exit();

    setTimeout(() => {
      closeActiveSession();
      history.push(clientId ? `/clients/${clientId}` : '/clients');
    }, 1000);
  };

  return (
    <PageHeader toolbarClassName={styles.header}>
      <div className={styles.inner}>
        <Button className={styles.backButton} onClick={() => setIsBackModalOpen(true)} variant='tertiary'>
          <Icon direction={IconRotate.West} name='chevron' size={13} />
          Back
        </Button>
        <div className={styles.titleContainer}>
          <span className={styles.title} style={{ marginRight: '4px' }}>
            {title}
          </span>

          <div className={styles.descriptionContainer}>
            <span className={styles.sessionTitle}>
              <Indicator /> New session
            </span>
            <span className={styles.seperator}> | </span>
            <span className={styles.date}>{currentDate}</span>
            <span className={styles.seperator}> · </span>
            <span className={styles.time}>{currentTime}</span>
          </div>
        </div>

        {isHubFlow && (
          <div slot='end'>
            <SensorHubIndicator title='Sensor Hub' />
          </div>
        )}

        <BackModal handleClose={() => setIsBackModalOpen(false)} isOpen={isBackModalOpen} onConfirm={onBack} />
      </div>
    </PageHeader>
  );
};
